import React                    from 'react';
import PropTypes                from 'prop-types';
import Flux                     from '../../flux/Flux';
import ProfileLiveShowButton    from '../Profile/ProfileLiveShow/ProfileLiveShowButton';
import ProfileLiveShowCountdown from '../Profile/ProfileLiveShow/ProfileLiveShowCountdown';
import Translations             from '../../utils/Translations';
import ReloadHelper             from "../../utils/ReloadHelper";

class ProfileHeaderTicketLiveShow extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			data: this.props.data,
		};

		this.loadData           = this.loadData.bind(this);
		this.onChatTicketChange = this.onChatTicketChange.bind(this);
	}

	componentDidMount() {
		Flux.NewMessenger.addChatTicketChangeListener(this.onChatTicketChange);
		!this.props.data && this.loadData();
	}

	componentDidUpdate(prevProps) {
		if (this.props.data && (prevProps !== this.props)) {
			this.setState({data: this.props.data});
		}
	}

	componentWillUnmount() {
		Flux.NewMessenger.removeChatTicketChangeListener(this.onChatTicketChange);
	}

	onChatTicketChange(result) {
		if (result && result.success && result.show.id === this.state.data.id) {
			Flux.NewMessenger.removeChatTicketChangeListener(this.onChatTicketChange);
			this.loadData();
		}
	}

	loadData() {
		Flux.Actor.getProfileLiveShowTicket(this.props.actorId, (ticketList) => {
			if (ticketList.length > 0) {
				const data = ticketList[0];
				this.setState({data});
			}
		});
	}

	render() {
		if (!this.state.data) {
			return null;
		}

		let headerTitle = this.props.isMobile ? '' : Translations.get('TicketLiveShowHeaderTitle');

		if (this.state.data.hasStarted) {
			headerTitle += ' ' + (this.props.isMobile ? Translations.get('cam_shows.show-end-in--short') : Translations.get('cam_shows.show-end-in'));
		} else {
			headerTitle += ' ' + (this.props.isMobile ? Translations.get('cams_shows.show-start-in--short') : Translations.get('cams_shows.show-start-in'));
		}

		const button = <ProfileLiveShowButton data={this.state.data}
		                                      actorId={this.props.actorId}
		                                      isHeader={true}
		                                      hasStarted={this.state.data.hasStarted}
		                                      isMobile={this.props.isMobile}
		/>;

		if (this.props.onlyButton) {
			return button;
		}

		return (
			<div className={"profile-header-live-show__wrapper" + (this.props.isMobile ? " profile-header-live-show__wrapper--mobile" : "")}>
				<div className="profile-header-live-show">
					<div className="profile-header-live-show__text">{headerTitle}</div>
					<ProfileLiveShowCountdown
						onEnd={() => {
							if (!this.state.data.hasStarted) {
								ReloadHelper.reloadCurrentPage(false);
							}
						}} start={this.state.data.start}
						end={this.state.data.end}
						isHeader={true}
						hasStarted={this.state.data.hasStarted}
						setHasStarted={this.loadData}
					>
						&nbsp;
					</ProfileLiveShowCountdown>
					<div className={"profile-header-live-show__buttons" + (this.props.messageButton ? "" : " profile-header-live-show__buttons--single")}>
						{button}
						{this.props.messageButton}
					</div>
				</div>
			</div>
		);
	}
}

ProfileHeaderTicketLiveShow.propTypes = {
	messageButton: PropTypes.node,
	actorId:       PropTypes.number,
	isMobile:      PropTypes.bool,
	onlyButton:    PropTypes.bool,
	data:          PropTypes.object,
};

ProfileHeaderTicketLiveShow.defaultProps = {
	isMobile:   false,
	onlyButton: false,
	data:       null,
};

export default ProfileHeaderTicketLiveShow;
